import Skeleton from "react-loading-skeleton";
import Button from "../../ui/Button";
import { ImageIcon } from "../../utils/icon.utils";
import Swal from "sweetalert2";

export default function AuctionSheetView({ url }) {
  const handleClick = () => {
    Swal.fire({
      imageUrl: url ?? "",
      imageAlt: "Auction Sheet"
    });
  };
  return <Button onClick={handleClick} icon={ImageIcon} name="Auction Sheet" />;
}

// AuctionSheetView skeleton
export function AuctionSheetViewSkeleton() {
  return <Skeleton width={`30%`} />;
}
